module.exports = __webpack_public_path__ + "static/media/chainlink.a34e24b2.svg";